export default __webpack_public_path__ + "static/cordys-2762ea2eaafecc60aa95bb48fa1a01df.webp";